Vue.component("Focused", {
    props: ["isContentOpen", "settings"],
    template: `
        <transition name="fadein">
            <div id="focused-overlay" 
                v-if="isContentOpen && settings.enabled"
                @click="focusClicked">
            </div>
        </transition>
    `,
    methods: {
        focusClicked() {
            this.$emit("closeAllContent")
        }
    }
})